export class CopyUtil {
  static deepCopy<T>(obj: any): T {
    return JSON.parse(JSON.stringify(obj));
  }
}
